/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';

/**
 * 
 * @export
 * @interface PostPersonsPersonIdImpersonate201Response
 */
export interface PostPersonsPersonIdImpersonate201Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof PostPersonsPersonIdImpersonate201Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof PostPersonsPersonIdImpersonate201Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {string}
     * @memberof PostPersonsPersonIdImpersonate201Response
     */
    result: string;
}

/**
 * Check if a given object implements the PostPersonsPersonIdImpersonate201Response interface.
 */
export function instanceOfPostPersonsPersonIdImpersonate201Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function PostPersonsPersonIdImpersonate201ResponseFromJSON(json: any): PostPersonsPersonIdImpersonate201Response {
    return PostPersonsPersonIdImpersonate201ResponseFromJSONTyped(json, false);
}

export function PostPersonsPersonIdImpersonate201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPersonsPersonIdImpersonate201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': json['result'],
    };
}

export function PostPersonsPersonIdImpersonate201ResponseToJSON(value?: PostPersonsPersonIdImpersonate201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': value.result,
    };
}

